<template>
  <div id="app">
    <!-- <keep-alive> -->
      <router-view></router-view>
    <!-- </keep-alive> -->
    <!-- <footers></footers> -->
  </div>
</template>

<script>
import footers from "./components/foot/footer.vue";
  export default {
    components: {
    footers: footers
   },
    data () {
      return {}
    },
    methods:{
   

    },
    created: function () {
    
    }
  }
</script>
<style>
	.swiperImg{
		margin-top: -20px;
	}
</style>




// WEBPACK FOOTER //
// App.vue?7553ce8e